export const config = {
  title: 'Clean Flower Company | Professional Cleaning Services in Compton, CA',
  meta: {
    description:
      'Clean Flower Company offers top-tier residential, commercial, and industrial cleaning services in Compton, CA. Experience spotless spaces with our expert team.',
    keywords: [
      'Clean Flower Company',
      'Cleaning Services Compton',
      'Residential Cleaning',
      'Commercial Cleaning',
      'Industrial Cleaning',
      'Airbnb Cleaning',
      'Window Cleaning',
      'General Cleaning',
      'Vacuum Cleaning',
      'Professional Cleaners',
    ],
    author: 'Clean Flower Company',
    canonicalUrl: 'https://cleanflowercompany.com/',
  },
  sections: {
    header: {
      businessName: 'Clean Flower Company',
    },
    sectionB: {
      heroTitle: 'Clean Flower Company',
      heroSubtitle: 'Expert Cleaning Services in Compton, CA',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '5626883158',
      phoneLabel: '(562) 688-3158',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=',
      cardData: [
        {
          title: 'Residential Cleaning',
          description:
            'Keep your home spotless with our comprehensive residential cleaning services tailored to your needs.',
        },
        {
          title: 'Commercial Cleaning',
          description:
            'Maintain a professional environment with our reliable and efficient commercial cleaning solutions.',
        },
        {
          title: 'Industrial Cleaning',
          description:
            'Ensure safety and cleanliness in your industrial spaces with our specialized cleaning services.',
        },
      ],
      description:
        'With over 6 years of experience, Clean Flower Company provides exceptional cleaning services across Compton, CA, ensuring hygienic and organized spaces for all clients.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our wide range of cleaning services designed to meet the unique needs of residential, commercial, and industrial clients.',
      cards: [
        {
          title: 'Airbnb Cleaning',
          description:
            'Ensure your guests have a pleasant stay with our thorough and timely Airbnb cleaning services.',
          imageSrc: 'https://cleanflowercompany.com/wp-content/uploads/elementor/thumbs/IMG-20250403-WA00141-r3u51ga8pcchz6b009frr3aqwuxpieabjcks2wnqxc.jpg',
          imageAlt: 'Airbnb Cleaning Service',
        },
        {
          title: 'Window Cleaning',
          description:
            'Enhance your view and let in more light with our professional window cleaning services.',
          imageSrc: 'https://cleanflowercompany.com/wp-content/uploads/elementor/thumbs/What-kind-of-soap-do-professional-window-washers-use_-scaled-1-1536x1024.jpeg-r3u90wfjp4ptstxsd9o39w56jrwa7hrmlcqep3ytcg.webp',
          imageAlt: 'Window Cleaning Service',
        },
        {
          title: 'General Cleaning',
          description:
            'Maintain a clean and healthy environment with our comprehensive general cleaning services.',
          imageSrc: 'https://cleanflowercompany.com/wp-content/uploads/elementor/thumbs/IMG-20250403-WA00151-r3u51j3r9ugcy06wjsnngkl4p0jt5hlijqj8iqjkeo.jpg',
          imageAlt: 'General Cleaning Service',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Vacuum Cleaning Services',
        'Deep Cleaning',
        'Move-In/Move-Out Cleaning',
        'Post-Construction Cleaning',
        'Customized Cleaning Plans',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://cleanflowercompany.com/wp-content/uploads/2025/04/cleaning-brush-copia1.png',
        alt: 'Clean Flower Company Team',
      },
      aboutText: [
        'Clean Flower Company is a leading cleaning service provider in Compton, CA, dedicated to delivering spotless and healthy environments for residential, commercial, and industrial clients.',
        'Our experienced team is trained in advanced cleaning techniques and uses specialized equipment to ensure efficient and safe service delivery.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Clean Flower Company Logo',
      businessName: 'Clean Flower Company',
      contact: {
        phone: '5626883158',
        phoneLabel: '(562) 688-3158',
        email: 'erwinglopez642@gmail.com',
        website: 'https://cleanflowercompany.com/',
        address: 'Compton, CA, USA',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Compton, CA, USA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d423286.2741144841!2d-118.41173235!3d33.8959285!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c901dd74a9e3%3A0xb1ed6b9f6e7c5678!2sCompton%2C%20CA%2C%20USA!5e0!3m2!1sen!2sus!4v1712696938000!5m2!1sen!2sus',
    }    
  },
};

export default config;
